import { Component, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NotificationService } from "@kno2/common/services/notifications";
import { SessionService } from "@kno2/core/session";
import { ResellersService } from "@kno2/data-access/resellers";
import { DialogBodyComponent, DialogFooterComponent, DialogService } from "@kno2/shared/dialog";

@Component({
    selector: "kno2-onboarding-terms-and-conditions-resellers-modal",
    imports: [FormsModule, DialogBodyComponent, DialogFooterComponent],
    templateUrl: "./onboarding-terms-and-conditions-resellers-modal.component.html"
})
export class OnboardingTermsAndConditionsResellersModalComponent {
    private readonly dialogService = inject(DialogService);
    private readonly sessionService = inject(SessionService);
    private readonly notificationService = inject(NotificationService);
    private readonly resellersService = inject(ResellersService);

    protected readonly userProfile = signal(this.sessionService.profileData());
    protected readonly acceptedTerms = signal(false);

    protected async acceptTermsAndConditions(): Promise<void> {
        if (!this.acceptedTerms()) return;

        const profile = this.userProfile();
        if (!profile?.resellerId) {
            this.notificationService.error("An error occurred. Please try again.");
            return;
        }

        try {
            await this.resellersService.acceptEulaAsync(profile.resellerId);
            this.sessionService.refreshProfile();
            this.dialogService.close(true);
        } catch {
            this.notificationService.error("An error occurred. Please try again.");
        }
    }
}
